import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { hasFeature } from "../../../components/Features";
import { companyCountries } from "../../../../utils/companyCountries";
import styles from "../reports.module.css";

/** International collections vs local delivery (Shop) bookings; only shown when the Shop add-on is on. */
const ServiceFilter = ({ report }) => {
    if (!hasFeature("shop")) return null;
    const { pickup, delivery } = companyCountries();

    return (<FormControl size="small" className={`${styles.SelectFilter}`}>
        <InputLabel>Service</InputLabel>
        <Select value={report.filters.service || "all"} label="Service" onChange={(e) => report.setFilter("service", e.target.value)}>
            <MenuItem value={"all"}>All services</MenuItem>
            <MenuItem value={"international"}>International ({pickup} to {delivery})</MenuItem>
            <MenuItem value={"local_delivery"}>Shop Orders ({pickup})</MenuItem>
        </Select>
    </FormControl>);
};

export default ServiceFilter;
